const worldBounds = [[-180, -90], [180, 90]]

const generateMaxBounds = (bounds, center, zoom) => {
  const maxBounds = bounds
        ? [
          [bounds[0][0] - 3, bounds[0][1] - 3],
          [bounds[1][0] + 3, bounds[1][1] + 3]
        ]
        : worldBounds
  // console.log(maxBounds)
  return maxBounds
}

export default generateMaxBounds



// WEBPACK FOOTER //
// ./src/utility/generateMaxBounds.js